(function () {
  var form = document.querySelector('[data-ll-returns-form]');
  if (!form) return;

  var configEl = document.querySelector('[data-ll-returns-config]');
  var config = {
    loggedIn: false,
    customerEmail: '',
    accountLoginUrl: '/account/login',
    accountOrdersUrl: '/account/orders',
    loginRequiredMessage: 'Please log in with the email used for your order to continue.',
    redirectMessage: 'Taking you to your account to complete your Shopify return request…',
    emailMismatchMessage: 'Please use the same email address as your order, or log in with that account.',
    submitFailedMessage: 'We could not continue to the return request right now. Please try again or contact us for help.'
  };

  if (configEl) {
    try {
      config = Object.assign(config, JSON.parse(configEl.textContent));
    } catch (e) {}
  }

  var summaryEl = form.querySelector('[data-ll-returns-summary]');
  var submitBtn = form.querySelector('[data-ll-returns-submit]');
  var submitLabel = form.querySelector('[data-ll-returns-submit-label]');
  var successContainer = form.querySelector('[data-ll-returns-success]');
  var defaultLabel = submitLabel ? submitLabel.textContent.trim() : 'Continue to Return Request';
  var isSubmitting = false;
  var storageKey = 'll_return_request';

  function fieldEl(name) {
    return form.querySelector('[data-field="' + name + '"]');
  }

  function fieldWrap(el) {
    return el ? el.closest('.ll-returns__lookup-field') : null;
  }

  function ensureErrorEl(wrap) {
    if (!wrap) return null;
    var errorEl = wrap.querySelector('[data-ll-field-error]');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'll-returns__field-error';
      errorEl.setAttribute('data-ll-field-error', '');
      errorEl.setAttribute('role', 'alert');
      wrap.appendChild(errorEl);
    }
    return errorEl;
  }

  function clearFieldError(el) {
    var wrap = fieldWrap(el);
    if (!wrap || !el) return;
    wrap.classList.remove('is-invalid');
    el.removeAttribute('aria-invalid');
    var errorEl = wrap.querySelector('[data-ll-field-error]');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function showFieldError(el, message) {
    var wrap = fieldWrap(el);
    if (!wrap || !el) return;
    var errorEl = ensureErrorEl(wrap);
    wrap.classList.add('is-invalid');
    el.setAttribute('aria-invalid', 'true');
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function clearAllErrors() {
    if (summaryEl) {
      summaryEl.hidden = true;
      summaryEl.textContent = '';
      summaryEl.classList.remove('ll-returns__note--success');
      summaryEl.classList.add('ll-returns__note--error');
    }
    form.querySelectorAll('[data-field]').forEach(clearFieldError);
  }

  function showSummary(message, isSuccess) {
    if (!summaryEl) return;
    summaryEl.textContent = message;
    summaryEl.hidden = false;
    summaryEl.classList.toggle('ll-returns__note--success', !!isSuccess);
    summaryEl.classList.toggle('ll-returns__note--error', !isSuccess);
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function normalizeOrderName(input) {
    var digits = String(input || '').replace(/\D/g, '');
    if (!digits) return '';
    return '#' + digits;
  }

  function normalizeEmail(value) {
    return String(value || '').trim().toLowerCase();
  }

  function validateAll() {
    clearAllErrors();
    var firstInvalid = null;
    var errorCount = 0;

    var orderEl = fieldEl('order_number');
    var order = orderEl && orderEl.value ? orderEl.value.trim() : '';
    if (!order) {
      showFieldError(orderEl, 'Please enter your order number.');
      firstInvalid = orderEl;
      errorCount += 1;
    }

    var emailEl = fieldEl('email');
    var email = emailEl && emailEl.value ? emailEl.value.trim() : '';
    if (!email) {
      showFieldError(emailEl, 'Please enter your email address.');
      if (!firstInvalid) firstInvalid = emailEl;
      errorCount += 1;
    } else if (!isValidEmail(email)) {
      showFieldError(emailEl, 'Please enter a valid email address.');
      if (!firstInvalid) firstInvalid = emailEl;
      errorCount += 1;
    }

    if (errorCount && summaryEl) {
      summaryEl.textContent =
        errorCount === 1
          ? 'Please fix the highlighted field below.'
          : 'Please fix the highlighted fields below.';
      summaryEl.hidden = false;
    }

    if (firstInvalid) {
      firstInvalid.focus();
      if (firstInvalid.scrollIntoView) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }

    return true;
  }

  function setSubmitting(busy) {
    isSubmitting = busy;
    if (!submitBtn) return;
    submitBtn.disabled = busy;
    submitBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (submitLabel) {
      submitLabel.textContent = busy ? 'Continuing…' : defaultLabel;
    }
  }

  function saveReturnHint(order, email) {
    try {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          order: order,
          email: email,
          createdAt: Date.now()
        })
      );
    } catch (e) {}
  }

  function buildRedirectUrl() {
    if (config.loggedIn) {
      return config.accountOrdersUrl;
    }
    return config.accountLoginUrl || config.accountOrdersUrl;
  }

  function continueToReturn(order, email) {
    saveReturnHint(order, email);
    showSummary(config.redirectMessage, true);

    if (successContainer) {
      successContainer.hidden = true;
    }

    window.setTimeout(function () {
      window.location.assign(buildRedirectUrl());
    }, 700);
  }

  form.querySelectorAll('[data-field]').forEach(function (el) {
    el.addEventListener('input', function () {
      clearFieldError(el);
      if (summaryEl) summaryEl.hidden = true;
    });
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (isSubmitting) return;
    if (!validateAll()) return;

    var orderEl = fieldEl('order_number');
    var emailEl = fieldEl('email');
    var order = normalizeOrderName(orderEl.value.trim());
    var email = normalizeEmail(emailEl.value);

    if (config.loggedIn && config.customerEmail && normalizeEmail(config.customerEmail) !== email) {
      showFieldError(emailEl, config.emailMismatchMessage);
      showSummary(config.emailMismatchMessage);
      return;
    }

    setSubmitting(true);

    try {
      continueToReturn(order, email);
    } catch (error) {
      setSubmitting(false);
      showSummary(config.submitFailedMessage);
    }
  });

  try {
    var saved = sessionStorage.getItem(storageKey);
    if (saved) {
      var parsed = JSON.parse(saved);
      if (parsed && parsed.order && Date.now() - parsed.createdAt < 3600000) {
        var orderEl = fieldEl('order_number');
        if (orderEl && !orderEl.value) {
          orderEl.value = parsed.order;
        }
      }
    }
  } catch (e) {}
})();
